'use strict';

export let annotationColors = [
	['general.yellow', '#ffd400'],
	['general.red', '#ff6666'],
	['general.green', '#5fb236'],
	['general.blue', '#2ea8e5'],
	['general.purple', '#a28ae5'],
	['general.magenta', '#e56eee'],
	['general.orange', '#f19837'],
	['general.gray', '#aaaaaa']
];

export let selectionColor = navigator.platform.includes('Mac') ? '#71ADFD' : 'Highlight';
